// Each watermark has its own immutable key. A stale tab cannot overwrite a newer one.
// This is browser-local state, not a server receipt or a record of lead processing.
export const deliverySeenPrefix = (userId: number) => `leadsmania:companion-delivery-seen:${userId}:`;

function parseKey(key: string, prefix: string) {
    if (!key.startsWith(prefix)) return null;
    const match = key.slice(prefix.length).match(/^([1-9]\d*):(0|[1-9]\d*)$/);
    if (!match) return null;
    const id = Number(match[1]);
    const count = Number(match[2]);
    return Number.isSafeInteger(id) && Number.isSafeInteger(count) ? { id: match[1], count } : null;
}

export function readDeliverySeen(userId: number): Record<string, number> {
    const result: Record<string, number> = {};
    const prefix = deliverySeenPrefix(userId);
    try {
        for (const key of Object.keys(localStorage)) {
            const value = parseKey(key, prefix);
            if (value && localStorage.getItem(key) === '1')
                result[value.id] = Math.max(result[value.id] ?? 0, value.count);
        }
    } catch {
        /* Memory in the current tab still works without storage. */
    }
    return result;
}

export function writeDeliverySeen(userId: number, counters: Record<string, number>) {
    const saved = readDeliverySeen(userId);
    const prefix = deliverySeenPrefix(userId);
    for (const [id, count] of Object.entries(counters)) {
        if (!parseKey(`${prefix}${id}:${count}`, prefix)) continue;
        if (saved[id] === undefined || count > saved[id]) {
            localStorage.setItem(`${prefix}${id}:${count}`, '1');
            saved[id] = count;
        }
    }
    // Never remove a higher watermark, including one written concurrently after our read.
    for (const key of Object.keys(localStorage)) {
        const value = parseKey(key, prefix);
        if (value && saved[value.id] !== undefined && value.count < saved[value.id]) localStorage.removeItem(key);
    }
    return readDeliverySeen(userId);
}
